import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getAcidityCatalog = state => state.models[name].data;
export const getCurAcidity = state => state.models[name].item;